import React, { useEffect } from "react";
import Header from "../Templete/Header";
import Footer from "../Templete/Footer";

const AboutUs = () => {
  useEffect(() => {
    document.title = "About Us | FORMAX MONEY";
  }, []);

  return (
    <>
      <Header />

      {/* Hero Section for About Page */}
      <section className="page-hero">
        <div className="container">
          <h1>About FORMAX MONEY</h1>
          <p>
            A bank-licensed Corporate Business Correspondent enabling financial
            inclusion through BC Agents across India.
          </p>
        </div>
      </section>

      <div className="container">
        {/* Main About Content */}
        <div className="about-content-full">
          <div className="about-grid">
            <div className="about-text-box">
              <h2>Who We Are</h2>
              <p>
                <strong>FORMAX MONEY</strong> is a brand of{" "}
                <strong>FORMAX IT SOLUTIONS PRIVATE LIMITED</strong> (CIN:
                U72900WB2018PTC228240), a registered company in India and a
                <strong> bank-licensed Corporate Business Correspondent</strong>
                .
              </p>
              <p>
                We are authorized by scheduled banks to appoint BC Agents and
                deliver last-mile banking and financial inclusion services
                across India. Our platform enables agents to offer essential
                services including{" "}
                <strong>
                  AEPS (Aadhaar Enabled Payment System), Domestic Money Transfer
                  (DMT), Cash Management Services (CMS), and UPI Cash Point
                </strong>{" "}
                to unbanked and underbanked communities.
              </p>
              <p>
                Our mission is to bridge the financial divide by empowering
                local entrepreneurs to become Banking Correspondents and serve
                their communities with secure, reliable, and affordable banking
                solutions.
              </p>
            </div>
            <div className="about-stats-card">
              <h3>
                <i className="fas fa-chart-line"></i> Why India Trusts Us
              </h3>
              <ul>
                <li>
                  <i className="fas fa-check-circle"></i> Bank Licensed BC
                </li>
                <li>
                  <i className="fas fa-check-circle"></i> 15+ Partner Banks
                </li>
                <li>
                  <i className="fas fa-check-circle"></i> 24/7 Agent Support
                </li>
                <li>
                  <i className="fas fa-check-circle"></i> Real-time Settlements
                </li>
                <li>
                  <i className="fas fa-check-circle"></i> 500+ Active BC Agents
                </li>
              </ul>
            </div>
          </div>

          {/* Mission & Vision */}
          <div className="mission-vision">
            <div className="mission">
              <i className="fas fa-bullseye"></i>
              <h3>Our Mission</h3>
              <p>
                To democratize banking access across every village and town in
                India by building a robust BC Agent network, enabling financial
                services at the doorstep of every citizen.
              </p>
            </div>
            <div className="vision">
              <i className="fas fa-eye"></i>
              <h3>Our Vision</h3>
              <p>
                To become India's most trusted Corporate Business Correspondent,
                empowering 10,000+ BC Agents and serving 1 crore+ customers with
                secure, innovative, and inclusive financial solutions.
              </p>
            </div>
          </div>

          {/* Core Values */}
          <div className="values-section">
            <h2>Our Core Values</h2>
            <div className="values-grid">
              <div className="value-card">
                <i className="fas fa-shield-alt"></i>
                <h4>Trust & Transparency</h4>
                <p>Complete transparency in all our operations and dealings</p>
              </div>
              <div className="value-card">
                <i className="fas fa-lightbulb"></i>
                <h4>Innovation</h4>
                <p>Leveraging technology for better financial access</p>
              </div>
              <div className="value-card">
                <i className="fas fa-hand-holding-heart"></i>
                <h4>Financial Inclusion</h4>
                <p>Bringing banking to every doorstep</p>
              </div>
              <div className="value-card">
                <i className="fas fa-chart-line"></i>
                <h4>Growth for All</h4>
                <p>Empowering BC Agents with growth opportunities</p>
              </div>
              <div className="value-card">
                <i className="fas fa-gavel"></i>
                <h4>Regulatory Compliance</h4>
                <p>Strict adherence to RBI guidelines</p>
              </div>
            </div>
          </div>

          {/* Key Milestones / Stats */}
          <div className="stats-section">
            <h2>Our Impact in Numbers</h2>
            <div className="stats-grid">
              <div className="stat-block">
                <h3>10K+</h3>
                <p>Active BC Agents</p>
              </div>
              <div className="stat-block">
                <h3>10+</h3>
                <p>Partner Banks</p>
              </div>
              <div className="stat-block">
                <h3>10M+</h3>
                <p>Monthly Transactions</p>
              </div>
              <div className="stat-block">
                <h3>24/7</h3>
                <p>Agent Support</p>
              </div>
            </div>
          </div>

          {/* Legal Details */}
          <div className="legal-details">
            <h2>Legal Information</h2>
            <div className="legal-grid">
              <div className="legal-item">
                <i className="fas fa-building"></i>
                <h4>Legal Entity</h4>
                <p>FORMAX IT SOLUTIONS PRIVATE LIMITED</p>
              </div>
              <div className="legal-item">
                <i className="fas fa-id-card"></i>
                <h4>CIN</h4>
                <p>U72900WB2018PTC228240</p>
              </div>
              <div className="legal-item">
                <i className="fas fa-file-invoice"></i>
                <h4>GSTIN</h4>
                <p>19AADCF5125F1ZT</p>
              </div>
              <div className="legal-item">
                <i className="fas fa-map-marker-alt"></i>
                <h4>Registered Office</h4>
                <p>
                  N0060, Mochpole, Near Junior School, Nabapally, Barasat,
                  Kolkata - 700126
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />

      <style>{`
        .page-hero {
          background: linear-gradient(135deg, #0A2540 0%, #1A3A5F 100%);
          padding: 60px 0 70px;
          text-align: center;
        }
        .page-hero h1 {
          font-size: 2.8rem;
          margin-bottom: 16px;
          color: white;
          font-weight: 700;
        }
        .page-hero p {
          color: rgba(255,255,255,0.85);
          max-width: 600px;
          margin: 0 auto;
          font-size: 1.1rem;
        }
        
        .about-content-full {
          margin: 60px 0;
        }
        
        .about-grid {
          display: flex;
          flex-wrap: wrap;
          gap: 48px;
          margin-bottom: 60px;
        }
        
        .about-text-box {
          flex: 1.5;
          min-width: 260px;
        }
        
        .about-text-box h2 {
          font-size: 2rem;
          margin-bottom: 20px;
          color: #0A2540;
          font-weight: 700;
        }
        
        .about-text-box p {
          margin-bottom: 20px;
          line-height: 1.6;
          color: #475569;
        }
        
        .about-stats-card {
          flex: 1;
          background: linear-gradient(135deg, #0A2540, #1A3A5F);
          padding: 32px;
          border-radius: 32px;
          box-shadow: 0 20px 25px -12px rgba(0,0,0,0.15);
        }
        
        .about-stats-card h3 {
          font-size: 1.5rem;
          margin-bottom: 20px;
          color: white;
        }
        
        .about-stats-card ul {
          list-style: none;
          padding-left: 0;
        }
        
        .about-stats-card li {
          margin-bottom: 14px;
          display: flex;
          align-items: center;
          gap: 12px;
          font-weight: 500;
          color: rgba(255,255,255,0.9);
        }
        
        .about-stats-card li i {
          color: #D4AF37;
          font-size: 1.2rem;
        }
        
        .mission-vision {
          display: flex;
          flex-wrap: wrap;
          gap: 40px;
          margin: 60px 0;
        }
        
        .mission, .vision {
          flex: 1;
          background: white;
          padding: 36px;
          border-radius: 28px;
          text-align: center;
          box-shadow: 0 10px 25px -5px rgba(0,0,0,0.05);
          border: 1px solid #eef2ff;
          transition: all 0.3s ease;
        }
        
        .mission:hover, .vision:hover {
          transform: translateY(-5px);
          box-shadow: 0 25px 30px -12px rgba(0,0,0,0.15);
          border-color: rgba(212, 175, 55, 0.3);
        }
        
        .mission i, .vision i {
          font-size: 3rem;
          color: #D4AF37;
          margin-bottom: 20px;
        }
        
        .mission h3, .vision h3 {
          font-size: 1.6rem;
          margin-bottom: 16px;
          color: #0A2540;
          font-weight: 700;
        }
        
        .mission p, .vision p {
          color: #475569;
          line-height: 1.6;
        }
        
        .values-section {
          margin: 60px 0;
          text-align: center;
        }
        
        .values-section h2 {
          font-size: 2rem;
          margin-bottom: 40px;
          color: #0A2540;
          font-weight: 700;
        }
        
        .values-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
          gap: 24px;
        }
        
        .value-card {
          background: white;
          padding: 28px 20px;
          border-radius: 24px;
          text-align: center;
          box-shadow: 0 5px 15px rgba(0,0,0,0.05);
          border: 1px solid #eef2ff;
          transition: all 0.3s ease;
        }
        
        .value-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 15px 30px -10px rgba(0,0,0,0.1);
          border-color: rgba(212, 175, 55, 0.3);
        }
        
        .value-card i {
          font-size: 2.5rem;
          color: #D4AF37;
          margin-bottom: 16px;
        }
        
        .value-card h4 {
          font-size: 1.2rem;
          margin-bottom: 12px;
          color: #0A2540;
          font-weight: 700;
        }
        
        .value-card p {
          color: #64748b;
          font-size: 0.9rem;
          line-height: 1.5;
        }
        
        .stats-section {
          margin: 60px 0 40px;
          text-align: center;
        }
        
        .stats-section h2 {
          font-size: 2rem;
          margin-bottom: 40px;
          color: #0A2540;
          font-weight: 700;
        }
        
        .stats-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
          gap: 30px;
        }
        
        .stat-block {
          background: white;
          padding: 32px 20px;
          border-radius: 28px;
          box-shadow: 0 10px 25px -5px rgba(0,0,0,0.05);
          border: 1px solid #eef2ff;
          transition: all 0.3s ease;
        }
        
        .stat-block:hover {
          transform: translateY(-5px);
          box-shadow: 0 20px 30px -12px rgba(0,0,0,0.1);
          border-color: rgba(212, 175, 55, 0.3);
        }
        
        .stat-block h3 {
          font-size: 2.2rem;
          font-weight: 800;
          color: #D4AF37;
          margin-bottom: 8px;
        }
        
        .stat-block p {
          color: #475569;
          font-weight: 500;
        }
        
        .legal-details {
          background: linear-gradient(135deg, #F8FAFE 0%, #F1F5F9 100%);
          border-radius: 32px;
          padding: 48px;
          margin: 60px 0 40px;
        }
        
        .legal-details h2 {
          text-align: center;
          margin-bottom: 40px;
          color: #0A2540;
          font-weight: 700;
        }
        
        .legal-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
          gap: 30px;
        }
        
        .legal-item {
          text-align: center;
        }
        
        .legal-item i {
          font-size: 2rem;
          color: #D4AF37;
          margin-bottom: 12px;
        }
        
        .legal-item h4 {
          font-size: 1.1rem;
          margin-bottom: 8px;
          color: #0A2540;
          font-weight: 700;
        }
        
        .legal-item p {
          color: #475569;
          font-size: 0.9rem;
        }
        
        @media (max-width: 768px) {
          .page-hero {
            padding: 40px 0 50px;
          }
          .page-hero h1 { 
            font-size: 2rem; 
          }
          .page-hero p {
            font-size: 1rem;
            padding: 0 20px;
          }
          .about-text-box h2 { 
            font-size: 1.6rem; 
          }
          .stat-block h3 { 
            font-size: 1.6rem; 
          }
          .mission h3, .vision h3 {
            font-size: 1.3rem;
          }
          .legal-details {
            padding: 32px 24px;
          }
          .values-section h2, .stats-section h2 {
            font-size: 1.6rem;
          }
        }
        
        @media (max-width: 576px) {
          .mission, .vision {
            padding: 24px;
          }
          .value-card {
            padding: 20px;
          }
          .stat-block {
            padding: 20px;
          }
        }
      `}</style>
    </>
  );
};

export default AboutUs;
